import React from "react";
import EncordLogo from "../assets/images/EncordLogo.svg";
import SignUpForm from "../utilities/SignUpForm";
import { Link } from "gatsby";
import { GitHubIcon } from "../assets/icons/gitHubIcon";
import { TwitterIcon } from "../assets/icons/twitterIcon";
import { GitHubWhiteIcon } from "../assets/icons/gitHubWhiteIcon";
import { TwitterWhiteIcon } from "../assets/icons/twitterWhiteIcon";
import { useLocation } from "@reach/router";
import LinkedInIcon from "../assets/icons/linkedInIcon";
import YouTubeIcon from "../assets/icons/youTubeIcon";
import SlackIcon from "../assets/icons/slackIcon";
import AIShareButtons from "../components/AIShareButtons";

const platform = [
  {
    text: "Data management",
    href: "/encord-index/",
  },
  {
    text: "Data annotation",
    href: "/annotate/",
  },
  {
    text: "Model evaluation",
    href: "/active/",
  },
  {
    text: "Data agents",
    href: "/data-agents/",
  },
  {
    text: "Labeling services",
    href: "/accelerate/",
  },
];

const solution = [
  {
    text: "Physical AI",
    href: "/physical-ai/",
  },
];

export const modalities = [
  {
    text: "Multimodal",
    href: "/multimodal/",
  },
  {
    text: "Image",
    href: "/image/",
  },
  {
    text: "Video",
    href: "/video/",
  },
  {
    text: "Document & text",
    href: "/document/",
  },
  {
    text: "Audio",
    href: "/audio/",
  },
  {
    text: "DICOM & NIfTI",
    href: "/dicom/",
  },
  {
    text: "LiDAR",
    href: "/lidar/",
  },
];

const resources = [
  {
    text: "Build vs Buy Calculator",
    href: "/build-vs-buy-calculator/",
  },
  {
    text: "Blog",
    href: "/blog/",
  },
  {
    text: "Webinars",
    href: "/webinars/",
  },
  {
    text: "Security",
    href: "/security/",
  },
  {
    text: "Documentation",
    href: "https://docs.encord.com/",
  },
  {
    text: "Learning hub",
    href: "/learning-hub",
  },
  {
    text: "Glossary",
    href: "/glossary/",
  },
  {
    text: "AI data readiness report",
    href: "/ai-data-readiness-report/",
  },
  {
    text: "Research papers",
    href: "/research-reports/",
  },
];

const guides = [
  {
    text: "Image annotation tools",
    href: "/blog/best-image-annotation-tools/",
  },
  {
    text: "Annotation tools for medical imaging",
    href: "/blog/best-open-source-annotation-medical-imaging",
  },
  {
    text: "Video annotation guide",
    href: "/blog/video-annotation-guide",
  },
  {
    text: "Image segmentation guide",
    href: "/blog/image-segmentation-for-computer-vision-best-practice-guide",
  },
  {
    text: "Data annotation guide",
    href: "/blog/automated-data-annotation-guide",
  },
  {
    text: "Data curation guide",
    href: "/blog/best-data-curation-tools-guide",
  },
  {
    text: "Data labeling ops guide",
    href: "/blog/build-data-labeling-ops",
  },
  {
    text: "Self-supervised learning guide",
    href: "/blog/dinov2-self-supervised-learning-explained",
  },
  {
    text: "Data management tools",
    href: "/blog/data-management-tools-for-computer-vision",
  },
];

const engage = [
  {
    text: "AI Data Chats",
    href: "/ai-data-chats/",
  },
  {
    text: "AI After Hours",
    href: "/ai-after-hours/",
  },
  {
    text: "Build vs Buy Calculator",
    href: "/build-vs-buy-calculator/",
  },
];

const company = [
  {
    text: "Pricing",
    href: "/pricing/",
  },
  {
    text: "Customers",
    href: "/customers/",
  },
  {
    text: "About",
    href: "/about-us/",
  },
  {
    text: "Careers",
    href: "/careers/",
  },
  {
    text: "Press",
    href: "/press/",
  },
  {
    text: "Contact us",
    href: "/contact-us/",
  },
];

export const footerTheme = {
  default: {
    background: "bg-white z-10",
    textColor: "text-gray-600",
    hoverTextColor: "text-gray-900",
    groupHeaderTextColor: "text-gray-2700",
    sectionHeaderTextColor: "text-gray-500",
    gitHubLogo: <GitHubIcon />,
    twitterLogo: <TwitterIcon />,
    linkedinLogo: <LinkedInIcon />,
    youtubeLogo: <YouTubeIcon />,
    slackLogo: <SlackIcon />,
    borderColor: "border-gray-200",
    isDivider: false,
    subFormContainerCalsses:
      "relative flex items-center max-w-xs rounded-full overflow-hidden shadow-card border-none",
    subFormInputClasses:
      "w-full px-3 py-2.5 pr-12 text-sm lg:text-base text-gray-800 border-none rounded-none form-input focus:ring-white focus:border-white placeholder:text-gray-2200",
    subBtnClasses: "absolute inset-0 left-auto bg-purple-1500 px-2",
    subBtnIconClasses: "flex-shrink-0 w-3 h-3 mx-3 text-purple-600 fill-white",
  },

  footerNewDesign: {
    background: "bg-white",
    textColor: "text-[#595959]",
    hoverTextColor: "text-neutral-800",
    groupHeaderTextColor: "text-neutral-800",
    sectionHeaderTextColor: "text-[#adadad]",
    gitHubLogo: <GitHubIcon />,
    twitterLogo: <TwitterIcon />,
    linkedinLogo: <LinkedInIcon />,
    youtubeLogo: <YouTubeIcon />,
    slackLogo: <SlackIcon />,
    borderColor: "border-[#d9d9d9]",
    isDivider: false,
    subFormContainerCalsses:
      "relative flex items-center max-w-xs rounded-full overflow-hidden shadow-card border-none",
    subFormInputClasses:
      "w-full px-3 py-2.5 pr-12 text-sm lg:text-base text-gray-800 border-none rounded-none form-input focus:ring-white focus:border-white placeholder:text-gray-2200",
    subBtnClasses: "absolute inset-0 left-auto bg-purple-1500 px-2",
    subBtnIconClasses: "flex-shrink-0 w-3 h-3 mx-3 text-purple-600 fill-white",
  },

  purple: {
    background: "bg-[#1d0642]",
    textColor: "text-gray-1600",
    hoverTextColor: "text-gray-1600",
    groupHeaderTextColor: "text-gray-2800",
    sectionHeaderTextColor: "text-gray-1800",
    gitHubLogo: <GitHubWhiteIcon />,
    twitterLogo: <TwitterWhiteIcon />,
    linkedinLogo: <LinkedInIcon />,
    youtubeLogo: <YouTubeIcon />,
    slackLogo: <SlackIcon />,
    borderColor: "border-t-[#1d0642]",
    isDivider: true,
    subFormContainerCalsses:
      "relative flex items-center max-w-xs rounded-full overflow-hidden",
    subFormInputClasses:
      "w-full px-3 py-2 pr-12 text-sm text-[#B9ACCE] border-[#85789A] bg-transparent rounded-full shadow-sm form-input focus:ring-[#85789A] focus:border-[#85789A] placeholder:text-[#B9ACCE]",
    subBtnClasses: "absolute inset-0 left-auto backgrooundSubscriberBtn",
    subBtnIconClasses: "flex-shrink-0 w-9 h-3 mx-3 text-white fill-current",
  },
  purpleWithoutOpacity: {
    background: "bg-[#1d0642]",
    textColor: "text-gray-1600",
    hoverTextColor: "text-gray-1600",
    groupHeaderTextColor: "text-gray-2800",
    sectionHeaderTextColor: "text-gray-1800",
    gitHubLogo: <GitHubWhiteIcon />,
    twitterLogo: <TwitterWhiteIcon />,
    linkedinLogo: <LinkedInIcon />,
    youtubeLogo: <YouTubeIcon />,
    slackLogo: <SlackIcon />,
    borderColor: "border-t-[#1d0642]",
    isDivider: true,
    subFormContainerCalsses:
      "relative flex items-center max-w-xs rounded-full overflow-hidden",
    subFormInputClasses:
      "w-full px-3 py-2 pr-12 text-sm text-[#B9ACCE] border-[#85789A] bg-transparent rounded-full shadow-sm form-input focus:ring-[#85789A] focus:border-[#85789A] placeholder:text-[#B9ACCE]",
    subBtnClasses: "absolute inset-0 left-auto backgrooundSubscriberBtn",
    subBtnIconClasses: "flex-shrink-0 w-9 h-3 mx-3 text-white fill-current",
  },
  newDefault: {
    background: "bg-white z-10 relative",
    textColor: "text-gray-600",
    hoverTextColor: "text-gray-900",
    groupHeaderTextColor: "text-gray-2700",
    sectionHeaderTextColor: "text-[#ADADAD]",
    gitHubLogo: <GitHubIcon />,
    twitterLogo: <TwitterIcon />,
    linkedinLogo: <LinkedInIcon />,
    youtubeLogo: <YouTubeIcon />,
    slackLogo: <SlackIcon />,
    borderColor: "border-gray-200",
    isDivider: false,
    subFormContainerCalsses:
      "relative flex items-center max-w-xs rounded-full overflow-hidden shadow-card border-none",
    subFormInputClasses:
      "w-full px-3 py-2.5 pr-12 text-sm lg:text-base text-gray-800 border-none rounded-none form-input focus:ring-white focus:border-white placeholder:text-gray-2200",
    subBtnClasses: "absolute inset-0 left-auto bg-purple-1500 px-2",
    subBtnIconClasses: "flex-shrink-0 w-3 h-3 mx-3 text-purple-600 fill-white",
  },
  transparent: {
    background: "bg-gray-2800",
    textColor: "text-gray-600",
    hoverTextColor: "text-gray-900",
    groupHeaderTextColor: "text-gray-2700",
    sectionHeaderTextColor: "text-gray-500",
    gitHubLogo: <GitHubIcon />,
    twitterLogo: <TwitterIcon />,
    linkedinLogo: <LinkedInIcon />,
    youtubeLogo: <YouTubeIcon />,
    slackLogo: <SlackIcon />,
    borderColor: "border-gray-200",
    isDivider: false,
    subFormContainerCalsses:
      "relative flex items-center max-w-xs rounded-full overflow-hidden shadow-card border-none",
    subFormInputClasses:
      "w-full px-3 py-2.5 pr-12 text-sm lg:text-base text-gray-800 border-none rounded-none form-input focus:ring-white focus:border-white placeholder:text-gray-2200",
    subBtnClasses: "absolute inset-0 left-auto bg-purple-1500 px-2",
    subBtnIconClasses: "flex-shrink-0 w-3 h-3 mx-3 text-purple-600 fill-white",
  },
};

const Footer = ({ theme = "footerNewDesign", isStickyCTA }) => {
  const location = useLocation();
  const careerPage = location.pathname === "/careers/";

  const showCTALocation =
    location.pathname === "/" ||
    location.pathname === "/annotate/" ||
    location.pathname === "/encord-index/" ||
    location.pathname === "/data-agents/";

  const currentTheme = footerTheme[theme] || footerTheme.footerNewDesign;

  // Get the appropriate hover class based on theme
  const getHoverClass = () => {
    if (theme === "footerNewDesign") return "${getHoverClass()}";
    if (theme === "default") return "hover:text-gray-900";
    if (theme === "purple" || theme === "purpleWithoutOpacity")
      return "hover:text-gray-1600";
    if (theme === "newDefault" || theme === "transparent")
      return "hover:text-gray-900";
    return "${getHoverClass()}"; // fallback to footerNewDesign
  };

  return (
    <footer className={currentTheme.background}>
      <div className="px-4 mx-auto sm:px-12 lg:px-5 max-w-7xl">
        <div
          className={`lg:mx-11 pt-0 ${showCTALocation ? "pb-32 md:pb-24 lg:pb-10" : "pb-10 lg:pb-16"} ${careerPage ? " pt-10 lg:pt-20" : ""} ${isStickyCTA && "mb-14"}`}
        >
          {/* Top area: Blocks */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 pt-10 md:pt-12 md:mb-12">
            {/* Newsletter Section - 4fr */}
            <div className="flex flex-col items-center md:items-start col-span-4 pr-[14px]">
              <div className="mb-[18px]">
                {/* Logo */}
                <Link to="/" className="inline-block" aria-label="encord logo">
                  <EncordLogo width={60} height={68} />
                </Link>
              </div>
              <div
                className={`text-base mb-[18px] text-center md:text-left ${currentTheme.textColor} tracking-[-0.4px]`}
              >
                <Link
                  to="/terms/"
                  className={`${getHoverClass()} hover:underline transition duration-150 ease-in-out`}
                >
                  Terms
                </Link>{" "}
                •{" "}
                <Link
                  to="/privacy/"
                  className={`${getHoverClass()} hover:underline transition duration-150 ease-in-out`}
                >
                  Privacy Policy
                </Link>
              </div>
              <div className="w-full max-w-[360px]">
                <h3
                  className={`${currentTheme.groupHeaderTextColor} font-semibold font-manrope text-lg mb-2 text-center md:text-left tracking-[-0.45px]`}
                >
                  Subscribe to our newsletter
                </h3>
                <p
                  className={`text-base ${currentTheme.textColor} tracking-[-0.4px] mb-[18px] text-center md:text-left`}
                >
                  Get occasional product updates and tutorials to your inbox.
                </p>
                <SignUpForm subscribe theme={theme} variant="footerNewDesign" />
              </div>
            </div>

            {/* Platform Column - 3fr */}
            <div className="hidden lg:block lg:col-span-3">
              <h3
                className={`${currentTheme.groupHeaderTextColor} font-semibold font-manrope text-lg mb-[14px] tracking-[-0.45px]`}
              >
                Platform
              </h3>

              {/* Product Section */}
              <div className="mb-6">
                <p
                  className={`${currentTheme.sectionHeaderTextColor} font-medium text-base h-[43px] mb-3 flex items-center tracking-[-0.4px]`}
                >
                  Product
                </p>
                <ul className="space-y-4">
                  {platform?.map((item, index) => (
                    <li key={index}>
                      <Link
                        to={item?.href}
                        className={`${currentTheme.textColor} ${getHoverClass()} font-medium text-base tracking-[-0.4px] transition duration-150 ease-in-out`}
                      >
                        {item?.text}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Modalities Section */}
              <div className="mb-6">
                <p
                  className={`${currentTheme.sectionHeaderTextColor} font-medium text-base h-[43px] mb-3 flex items-center tracking-[-0.4px]`}
                >
                  Modalities
                </p>
                <ul className="space-y-4">
                  {modalities?.map((item, index) => (
                    <li key={index}>
                      <Link
                        to={item?.href}
                        className={`${currentTheme.textColor} ${getHoverClass()} font-medium text-base tracking-[-0.4px] transition duration-150 ease-in-out`}
                      >
                        {item?.text}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Solution Section */}
              <div className="mb-6">
                <p
                  className={`${currentTheme.sectionHeaderTextColor} font-medium text-base h-[43px] mb-3 flex items-center tracking-[-0.4px]`}
                >
                  Solution
                </p>
                <ul className="space-y-[14px]">
                  {solution?.map((item, index) => (
                    <li key={index}>
                      <Link
                        to={item?.href}
                        className={`${currentTheme.textColor} ${getHoverClass()} font-medium text-base tracking-[-0.4px] transition duration-150 ease-in-out`}
                      >
                        {item?.text}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Security and Governance Section */}
              <div>
                <p
                  className={`${currentTheme.sectionHeaderTextColor} font-medium text-base h-[43px] mb-3 flex items-center tracking-[-0.4px]`}
                >
                  Security and Governance
                </p>
                <ul className="space-y-[14px]">
                  <li>
                    <Link
                      to="/security/"
                      className={`${currentTheme.textColor} ${getHoverClass()} font-medium text-base tracking-[-0.4px] transition duration-150 ease-in-out`}
                    >
                      Security
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* Learn Column - 3fr */}
            <div className="hidden lg:block lg:col-span-3">
              <h3
                className={`${currentTheme.groupHeaderTextColor} font-semibold font-manrope text-lg mb-[14px] tracking-[-0.45px]`}
              >
                Learn
              </h3>

              {/* Resources Section */}
              <div className="mb-6">
                <p
                  className={`${currentTheme.sectionHeaderTextColor} font-medium text-base h-[43px] mb-3 flex items-center tracking-[-0.4px]`}
                >
                  Resources
                </p>
                <ul className="space-y-4">
                  {resources?.slice(2).map((item, index) => (
                    <li key={index}>
                      {item.text === "Documentation" ? (
                        <a
                          href={item?.href}
                          target="_blank"
                          rel="noreferrer"
                          className={`${currentTheme.textColor} ${getHoverClass()} font-medium text-base tracking-[-0.4px] transition duration-150 ease-in-out`}
                        >
                          {item?.text}
                        </a>
                      ) : (
                        <Link
                          to={item?.href}
                          className={`${currentTheme.textColor} ${getHoverClass()} font-medium text-base tracking-[-0.4px] transition duration-150 ease-in-out`}
                        >
                          {item?.text}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Engage Section */}
              <div className="mb-6">
                <p
                  className={`${currentTheme.sectionHeaderTextColor} font-medium text-base h-[43px] mb-3 flex items-center tracking-[-0.4px]`}
                >
                  Engage
                </p>
                <ul className="space-y-4">
                  {engage?.map((item, index) => (
                    <li key={index}>
                      <Link
                        to={item?.href}
                        className={`${currentTheme.textColor} ${getHoverClass()} font-medium text-base tracking-[-0.4px] transition duration-150 ease-in-out`}
                      >
                        {item?.text}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Guides Section */}
              <div>
                <p
                  className={`${currentTheme.sectionHeaderTextColor} font-medium text-base h-[43px] mb-3 flex items-center tracking-[-0.4px]`}
                >
                  Guides
                </p>
                <ul className="space-y-4">
                  {guides?.map((item, index) => (
                    <li key={index}>
                      <Link
                        to={item?.href}
                        className={`${currentTheme.textColor} ${getHoverClass()} font-medium text-base tracking-[-0.4px] transition duration-150 ease-in-out`}
                      >
                        {item?.text}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Company Column - 3fr */}
            <div className="hidden lg:block lg:col-span-2">
              <h3
                className={`${currentTheme.groupHeaderTextColor} font-semibold font-manrope text-lg mb-[14px] tracking-[-0.45px]`}
              >
                Company
              </h3>

              <div>
                <p
                  className={`${currentTheme.sectionHeaderTextColor} font-medium text-base mb-3 tracking-[-0.4px] h-[43px] flex items-center`}
                >
                  Company
                </p>
                <ul className="space-y-4">
                  {company?.map((item, index) => (
                    <li key={index}>
                      <Link
                        to={item?.href}
                        className={`${currentTheme.textColor} ${getHoverClass()} font-medium text-base tracking-[-0.4px] transition duration-150 ease-in-out`}
                      >
                        {item?.text}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Mobile Layout - Stacked sections */}
            <div className="block lg:hidden col-span-4">
              {/* Platform Section */}
              <div>
                <h3
                  className={`${currentTheme.groupHeaderTextColor} font-semibold font-manrope text-lg mb-1 tracking-[-0.45px]`}
                >
                  Platform
                </h3>
                <div className={`border-b ${currentTheme.borderColor} pb-8`}>
                  <div className="grid grid-cols-2 gap-3">
                    {/* Product Column */}
                    <div>
                      <p
                        className={`${currentTheme.sectionHeaderTextColor} font-medium text-base tracking-[-0.4px] mb-1 h-12 flex items-center`}
                      >
                        Product
                      </p>
                      <ul className="space-y-6">
                        {platform?.map((item, index) => (
                          <li key={index}>
                            <Link
                              to={item?.href}
                              className={`${currentTheme.groupHeaderTextColor} ${getHoverClass()} font-medium text-base tracking-[-0.4px] transition duration-150 ease-in-out`}
                            >
                              {item?.text}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* Modalities Column */}
                    <div>
                      <p
                        className={`${currentTheme.sectionHeaderTextColor} font-medium text-base tracking-[-0.4px] mb-1 h-12 flex items-center`}
                      >
                        Modalities
                      </p>
                      <ul className="space-y-6">
                        {modalities?.map((item, index) => (
                          <li key={index}>
                            <Link
                              to={item?.href}
                              className={`${currentTheme.groupHeaderTextColor} ${getHoverClass()} font-medium text-base tracking-[-0.4px] transition duration-150 ease-in-out`}
                            >
                              {item?.text}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-3 mt-8">
                    {/* Solution Column */}
                    <div>
                      <p
                        className={`${currentTheme.sectionHeaderTextColor} font-semibold text-base tracking-[-0.4px] mb-1 h-12 flex items-center`}
                      >
                        Solution
                      </p>
                      <ul className="space-y-[14px]">
                        {solution?.map((item, index) => (
                          <li key={index}>
                            <Link
                              to={item?.href}
                              className={`${currentTheme.groupHeaderTextColor} ${getHoverClass()} font-medium text-base tracking-[-0.4px] transition duration-150 ease-in-out`}
                            >
                              {item?.text}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* Security Column */}
                    <div>
                      <p
                        className={`${currentTheme.sectionHeaderTextColor} font-semibold text-base tracking-[-0.4px] mb-1 h-12 flex items-center`}
                      >
                        Security and Governance
                      </p>
                      <ul className="space-y-[14px]">
                        <li>
                          <Link
                            to="/security/"
                            className={`${currentTheme.groupHeaderTextColor} ${getHoverClass()} font-medium text-base tracking-[-0.4px] transition duration-150 ease-in-out`}
                          >
                            Security
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* Learn Section */}
              <div>
                <h3
                  className={`${currentTheme.groupHeaderTextColor} font-semibold font-manrope text-lg tracking-[-0.45px] pt-5`}
                >
                  Learn
                </h3>
                <div className={`border-b ${currentTheme.borderColor} pb-8`}>
                  <div className="grid grid-cols-2 gap-3">
                    {/* Resources Column */}
                    <div>
                      <p
                        className={`${currentTheme.sectionHeaderTextColor} font-medium text-base tracking-[-0.4px] mb-1 h-12 flex items-center`}
                      >
                        Resources
                      </p>
                      <ul className="space-y-6">
                        {resources?.slice(2, 18).map((item, index) => (
                          <li key={index}>
                            {item.text === "Documentation" ? (
                              <a
                                href={item?.href}
                                target="_blank"
                                rel="noreferrer"
                                className={`${currentTheme.groupHeaderTextColor} ${getHoverClass()} font-medium text-base tracking-[-0.4px] transition duration-150 ease-in-out`}
                              >
                                {item?.text}
                              </a>
                            ) : (
                              <Link
                                to={item?.href}
                                className={`${currentTheme.groupHeaderTextColor} ${getHoverClass()} font-medium text-base tracking-[-0.4px] transition duration-150 ease-in-out`}
                              >
                                {item?.text}
                              </Link>
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* Engage Column */}
                    <div>
                      <p
                        className={`${currentTheme.sectionHeaderTextColor} font-medium text-base tracking-[-0.4px] mb-1 h-12 flex items-center`}
                      >
                        Engage
                      </p>
                      <ul className="space-y-6">
                        {engage?.map((item, index) => (
                          <li key={index}>
                            <Link
                              to={item?.href}
                              className={`${currentTheme.groupHeaderTextColor} ${getHoverClass()} font-medium text-base tracking-[-0.4px] transition duration-150 ease-in-out`}
                            >
                              {item?.text}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* Engage Column */}
                    <div>
                      <p
                        className={`${currentTheme.sectionHeaderTextColor} font-medium text-base tracking-[-0.4px] mb-1 h-12 flex items-center`}
                      >
                        Guides
                      </p>
                      <ul className="space-y-6">
                        {guides?.map((item, index) => (
                          <li key={index}>
                            <Link
                              to={item?.href}
                              className={`${currentTheme.groupHeaderTextColor} ${getHoverClass()} font-medium text-base tracking-[-0.4px] transition duration-150 ease-in-out`}
                            >
                              {item?.text}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* Company Section */}
              <div>
                <h3
                  className={`${currentTheme.groupHeaderTextColor} font-semibold font-manrope text-lg mb-1 tracking-[-0.45px] pt-5`}
                >
                  Company
                </h3>
                <div className="pb-8">
                  <p
                    className={`${currentTheme.sectionHeaderTextColor} font-medium text-base tracking-[-0.4px] mb-1 h-12 flex items-center`}
                  >
                    Company
                  </p>
                  <ul className="space-y-6">
                    {company?.map((item, index) => (
                      <li key={index}>
                        <Link
                          to={item?.href}
                          className={`${currentTheme.groupHeaderTextColor} ${getHoverClass()} font-medium text-base tracking-[-0.4px] transition duration-150 ease-in-out`}
                        >
                          {item?.text}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Badges Section */}
          <div className="flex flex-col lg:flex-row justify-between items-center lg:items-start gap-5 mb-8 lg:mb-16">
            <div className="flex gap-3 items-center">
              <a
                className="w-[70px] h-[70px]"
                href="https://trust.encord.com/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="https://encord.cdn.prismic.io/encord/Z8mtUBsAHJWomMBQ_Vanta_Compliance_SOC21.svg"
                  height={70}
                  width={70}
                  alt="Soc2 badge"
                  loading="lazy"
                />
              </a>
              <div className="w-[70px] h-[70px]">
                <img
                  src="https://images.prismic.io/encord/d5a5f02e-d8df-49c2-9413-5633a8e75e7d_soc2-certificate.png?auto=compress,format"
                  alt="Soc2 certificate"
                  height={70}
                  width={70}
                  loading="lazy"
                />
              </div>
            </div>

            <div className="flex flex-wrap gap-3 justify-center lg:justify-end">
              <img
                className="w-[58px] h-auto"
                src="https://encord.cdn.prismic.io/encord/Z_Ork3dAxsiBwY-i_DataLabeling_BestSupport_QualityOfSupport.svg"
                alt="DataLabeling_BestSupport"
                loading="lazy"
                width={58}
                height={67}
              />
              <img
                className="w-[58px] h-auto"
                src="https://encord.cdn.prismic.io/encord/Z_OrkndAxsiBwY-h_DataLabeling_EasiestToUse_EaseOfUse.svg"
                alt="DataLabeling_EasiestToUse"
                loading="lazy"
                width={58}
                height={67}
              />
              <img
                className="w-[58px] h-auto"
                src="https://encord.cdn.prismic.io/encord/Z_OrkXdAxsiBwY-f_DataLabeling_MomentumLeader_Leader.svg"
                alt="DataLabeling_MomentumLeader"
                loading="lazy"
                width={58}
                height={67}
              />
              <img
                className="w-[58px] h-auto"
                src="https://encord.cdn.prismic.io/encord/Z_OrkHdAxsiBwY-e_MLOpsPlatforms_HighPerformer_HighPerformer.svg"
                alt="MLOpsPlatforms_HighPerformer"
                loading="lazy"
                width={58}
                height={67}
              />
            </div>
          </div>

          {/* Bottom area */}
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between py-2 gap-4 lg:gap-0">
            {/* Copyright */}
            <div
              className={`text-base tracking-[-0.4px] ${currentTheme.textColor} order-1 lg:order-none text-center lg:text-left`}
            >
              &copy; {new Date().getFullYear()} Encord. All rights reserved.
            </div>

            {/* Social links */}
            <ul className="flex mb-4 md:order-1 md:ml-4 gap-4 items-center md:mb-0 mt-4 lg:mt-0 justify-center">
              <li>
                <Link
                  to="https://www.linkedin.com/company/encord-team/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                  className="block w-5 h-5 lg:w-6 lg:h-6"
                >
                  {currentTheme.linkedinLogo}
                </Link>
              </li>
              <li>
                <Link
                  to="https://www.youtube.com/channel/UCySY39IUFp5yEReD2rSEXNg/"
                  target="_blank"
                  aria-label="Youtube"
                  rel="noopener noreferrer"
                  className="block w-5 h-5 lg:w-6 lg:h-6"
                >
                  {currentTheme.youtubeLogo}
                </Link>
              </li>
              <li>
                <Link
                  href="https://github.com/encord-team"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Github"
                  className="block w-5 h-5 lg:w-6 lg:h-6"
                >
                  {currentTheme.gitHubLogo}
                </Link>
              </li>
            </ul>
            {/* Summarize with AI and Social Links */}
            <div className="flex flex-col lg:flex-row items-center gap-4 lg:gap-6 order-2 lg:order-none">
              <div className="flex justify-center w-full lg:w-auto">
                <AIShareButtons variant="dark" location="footer" />
              </div>
            </div>
          </div>

          {/* Company Legal Info */}
          <div className="py-4 text-center lg:text-left">
            <div
              className={`text-base tracking-[-0.4px] ${currentTheme.textColor}`}
            >
              © Cord Technologies, Inc.
              <br />© Cord Technologies Limited
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
